import type {
  WBudgetItemView,
  WBudgetItemTypeView,
  WBudgetTaxonomyNodeView,
  WBudgetView,
  WBudgetItemPaymentView,
} from '@zola/svc-web-api-ts-client';

export enum ActionTypes {
  RECEIVE_BUSY = 'RECEIVE_BUSY',
  RECEIVE_BUDGET = 'RECEIVE_BUDGET',
  RECEIVE_ITEM = 'RECEIVE_ITEM',
  RECEIVE_DELETED_ITEM = 'RECEIVE_DELETED_ITEM',
  RECEIVE_ITEM_TYPES = 'RECEIVE_ITEM_TYPES',
  RECEIVE_TAXONOMY_NODES = 'RECEIVE_TAXONOMY_NODES',
  RECEIVE_UNSAVED_MAX_SPEND = 'RECEIVE_UNSAVED_MAX_SPEND',
  RECEIVE_UNSAVED_ITEM = 'RECEIVE_UNSAVED_ITEM',
  RECEIVE_UNSAVED_GROUPS = 'RECEIVE_UNSAVED_GROUPS',
  CLEAR_MAX_SPEND_FROM_UNSAVED = 'CLEAR_MAX_SPEND_FROM_UNSAVED',
  CLEAR_ITEM_FROM_UNSAVED = 'CLEAR_ITEM_FROM_UNSAVED',
  CLEAR_GROUPS_FROM_UNSAVED = 'CLEAR_GROUPS_FROM_UNSAVED',
  RECEIVE_PAYMENT = 'RECEIVE_PAYMENT',
  RECEIVE_DELETED_PAYMENT = 'RECEIVE_DELETED_PAYMENT',
}

type RECEIVE_BUDGET_ACTION = {
  type: typeof ActionTypes.RECEIVE_BUDGET;
  payload: {
    budget: WBudgetView;
  };
};

type RECEIVE_BUSY_ACTION = {
  type: typeof ActionTypes.RECEIVE_BUSY;
  payload: {
    busy: boolean;
  };
};

type RECEIVE_ITEM_ACTION = {
  type: typeof ActionTypes.RECEIVE_ITEM;
  payload: {
    item: WBudgetItemView;
  };
};

type RECEIVE_DELETED_ITEM_ACTION = {
  type: typeof ActionTypes.RECEIVE_DELETED_ITEM;
  payload: {
    itemUuid: string;
  };
};

type RECEIVE_ITEM_TYPES_ACTION = {
  type: typeof ActionTypes.RECEIVE_ITEM_TYPES;
  payload: {
    itemTypes: WBudgetItemTypeView[];
  };
};

type RECEIVE_TAXONOMY_NODES_ACTION = {
  type: typeof ActionTypes.RECEIVE_TAXONOMY_NODES;
  payload: {
    taxonomyNodes: WBudgetTaxonomyNodeView[];
  };
};

type RECEIVE_UNSAVED_MAX_SPEND_ACTION = {
  type: typeof ActionTypes.RECEIVE_UNSAVED_MAX_SPEND;
  payload: {
    maxSpend: number;
  };
};

type RECEIVE_UNSAVED_ITEM_ACTION = {
  type: typeof ActionTypes.RECEIVE_UNSAVED_ITEM;
  payload: {
    itemUuid: string;
    fields: WBudgetItemView;
  };
};

type RECEIVE_UNSAVED_GROUPS_ACTION = {
  type: typeof ActionTypes.RECEIVE_UNSAVED_GROUPS;
  payload: {
    groups: WBudgetTaxonomyNodeView[];
  };
};

type CLEAR_MAX_SPEND_FROM_UNSAVED_ACTION = {
  type: typeof ActionTypes.CLEAR_MAX_SPEND_FROM_UNSAVED;
};

type CLEAR_ITEM_FROM_UNSAVED_ACTION = {
  type: typeof ActionTypes.CLEAR_ITEM_FROM_UNSAVED;
  payload: {
    itemUuid: string;
  };
};

type RECEIVE_PAYMENT_ACTION = {
  type: typeof ActionTypes.RECEIVE_PAYMENT;
  payload: {
    payment: WBudgetItemPaymentView;
  };
};

type RECEIVE_DELETED_PAYMENT_ACTION = {
  type: typeof ActionTypes.RECEIVE_DELETED_PAYMENT;
  payload: {
    paymentUuid: string;
  };
};

type CLEAR_GROUPS_FROM_UNSAVED_ACTION = {
  type: typeof ActionTypes.CLEAR_GROUPS_FROM_UNSAVED;
};

export type BudgetActionTypes =
  | RECEIVE_BUDGET_ACTION
  | RECEIVE_BUSY_ACTION
  | RECEIVE_ITEM_ACTION
  | RECEIVE_DELETED_ITEM_ACTION
  | RECEIVE_ITEM_TYPES_ACTION
  | RECEIVE_TAXONOMY_NODES_ACTION
  | RECEIVE_UNSAVED_MAX_SPEND_ACTION
  | RECEIVE_UNSAVED_ITEM_ACTION
  | RECEIVE_UNSAVED_GROUPS_ACTION
  | CLEAR_ITEM_FROM_UNSAVED_ACTION
  | CLEAR_MAX_SPEND_FROM_UNSAVED_ACTION
  | CLEAR_GROUPS_FROM_UNSAVED_ACTION
  | RECEIVE_PAYMENT_ACTION
  | RECEIVE_DELETED_PAYMENT_ACTION;
